(function(){
  function initOne(root){
    if(root.__sbInit) return; root.__sbInit = true;
    var TOP_LABEL = root.getAttribute('data-top-label') || 'Top-Empfehlung';
    var MAX = parseInt(root.getAttribute('data-max') || '3', 10);
    var CART_MODE = root.getAttribute('data-cart-mode') || 'drawer';
    /* TEST: Ergebnis-Erklaerung ein/aus (Section-Setting "debug_ergebnis") */
    var DEBUG = root.getAttribute('data-debug') === 'true';
    var questions = [], products = [];
    try { questions = JSON.parse(root.querySelector('[data-sb-questions]').textContent) || []; } catch(e){}
    try { products = JSON.parse(root.querySelector('[data-sb-products]').textContent) || []; } catch(e){}
    var state = { screen:'intro', step:0, answers:[], recommended:[], added:{} };
    var q = function(s){ return root.querySelector(s); };
    var elSplit=q('[data-screen="split"]'), elResult=q('[data-screen="result"]'), elFallback=q('[data-screen="fallback"]');
    var panelIntro=q('[data-panel="intro"]'), panelQ=q('[data-panel="question"]');
    var rightIntro=q('[data-right="intro"]'), rightQ=q('[data-right="question"]');
    var elStep=q('[data-el="steplabel"]'), elProg=q('[data-el="progress"]'), elQTitle=q('[data-el="qtitle"]');
    var elOpts=q('[data-el="opts"]'), elProducts=q('[data-el="products"]'), elResSub=q('[data-el="result-sub"]');
    function show(el,on){ if(el) el.hidden = !on; }
    function parseTags(str){ if(!str) return []; return str.split(',').map(function(t){return t.trim().toLowerCase();}).filter(Boolean); }
    function recommend(){
      var wanted=[]; state.answers.forEach(function(a){ if(a&&a.tags) wanted=wanted.concat(parseTags(a.tags)); });
      var scored=products.map(function(p){
        var pt=(p.tags||[]).map(function(t){return String(t).toLowerCase();}); var sc=0;
        wanted.forEach(function(w){ if(pt.indexOf(w)!==-1) sc++; }); return {p:p,score:sc};
      });
      var matched=scored.filter(function(s){return s.score>0;});
      if(wanted.length===0){ matched=scored.slice(); }
      matched.sort(function(a,b){ if(b.score!==a.score) return b.score-a.score; return (b.p.available?1:0)-(a.p.available?1:0); });
      var avail=matched.filter(function(s){return s.p.available;});
      var pick=(avail.length?avail:matched);
      /* TEST: Bewertung fuer die Ergebnis-Erklaerung merken */
      state.sbDebug={ wanted:wanted, pick:pick.slice(0,MAX+3), onlyAvail:avail.length>0 };
      return pick.slice(0,MAX).map(function(s){return s.p;});
    }
    /* === TEST: Ergebnis-Erklaerung ============================================
       Zum Entfernen: diese beiden Funktionen, die Aufrufe renderDebug()/
       renderDebugFallback(), die state.sbDebug-Zeile in recommend(), die
       Debug-Boxen im Liquid, den CSS-Block .sb-debug und das Section-Setting
       "debug_ergebnis" loeschen. Zum Ausblenden reicht der Haken im Theme-Editor.
       ========================================================================= */
    function fillDebug(el,title,lines){
      el.innerHTML='';
      var head=document.createElement('b'); head.textContent=title; el.appendChild(head);
      lines.forEach(function(l){ var r=document.createElement('div'); r.textContent='• '+l; el.appendChild(r); });
      el.hidden=false;
    }
    function renderDebug(){
      var el=q('[data-el="debug"]'); if(!el) return;
      if(!DEBUG){ el.hidden=true; return; }
      var lines=[];
      state.answers.forEach(function(a,i){
        if(!a) return;
        var qq=questions[i];
        lines.push('Frage '+(i+1)+(qq&&qq.title?' „'+qq.title+'“':'')+' → Antwort „'+a.label+'“'+(a.tags?' · Match-Tags: '+a.tags:' · keine Match-Tags'));
      });
      var dbg=state.sbDebug||{};
      lines.push('Gesuchte Tags gesamt: '+((dbg.wanted&&dbg.wanted.length)?dbg.wanted.join(', '):'keine → alle Produkte aus dem Pool kommen infrage'));
      (dbg.pick||[]).forEach(function(s,i){
        lines.push((i<MAX?'✓ gezeigt: ':'· nicht gezeigt: ')+'„'+s.p.title+'“ → Tag-Treffer: '+s.score+(s.p.available?'':' · nicht verfügbar'));
      });
      lines.push('Sortierung: meiste Tag-Treffer zuerst'+(dbg.onlyAvail?', nur verfügbare Produkte':'')+', maximal '+MAX+' Produkte.');
      fillDebug(el,'Warum dieses Ergebnis? (Test-Anzeige – im Theme-Editor abschaltbar)',lines);
    }
    function renderDebugFallback(){
      var el=q('[data-el="debug-fallback"]'); if(!el) return;
      if(!DEBUG){ el.hidden=true; return; }
      var lines=[];
      state.answers.forEach(function(a,i){
        if(a&&a.fallback) lines.push('Frage '+(i+1)+': Antwort „'+a.label+'“ ist als „Führt zum Fallback“ markiert');
      });
      if(!lines.length) lines.push('Kein Produkt mit passenden Tags im Produkt-Pool gefunden');
      fillDebug(el,'Warum Fallback? (Test-Anzeige – im Theme-Editor abschaltbar)',lines);
    }
    function renderScreen(){
      var isSplit = state.screen==='intro'||state.screen==='question';
      show(elSplit,isSplit); show(elResult,state.screen==='result'); show(elFallback,state.screen==='fallback');
      if(isSplit){
        show(panelIntro,state.screen==='intro'); show(panelQ,state.screen==='question');
        show(rightIntro,state.screen==='intro'); show(rightQ,state.screen==='question');
        if(state.screen==='question') renderQuestion();
      }
      if(state.screen==='result') renderResult();
      /* TEST */ if(state.screen==='fallback') renderDebugFallback();
    }
    function renderQuestion(){
      var qq=questions[state.step]; if(!qq) return;
      elStep.textContent='Schritt '+(state.step+1)+' von '+questions.length;
      var pct=Math.round(((state.step+1)/questions.length)*100);
      requestAnimationFrame(function(){ elProg.style.width=pct+'%'; });
      elQTitle.textContent=qq.title; elOpts.innerHTML='';
      (qq.options||[]).forEach(function(opt){
        var btn=document.createElement('button'); btn.type='button'; btn.className='sb-opt';
        var wrap=document.createElement('span'); wrap.style.cssText='display:flex;flex-direction:column;gap:2px;';
        var lab=document.createElement('span'); lab.className='sb-optlabel'; lab.textContent=opt.label; wrap.appendChild(lab);
        if(opt.sub){ var s=document.createElement('span'); s.className='sb-optsub'; s.textContent=opt.sub; wrap.appendChild(s); }
        var arr=document.createElement('span'); arr.className='sb-arrow'; arr.textContent='→';
        btn.appendChild(wrap); btn.appendChild(arr);
        btn.addEventListener('click',function(){ choose(opt); }); elOpts.appendChild(btn);
      });
      var box=q('.sb-qbox'); if(box){ box.classList.remove('sb-fade'); void box.offsetWidth; box.classList.add('sb-fade'); }
    }
    function renderResult(){
      var list=state.recommended;
      elResSub.textContent=list.length+(list.length===1?' Produkt passt':' Produkte passen')+' zu Ihren Angaben.';
      elProducts.innerHTML='';
      list.forEach(function(p,i){
        var badge=p.badge||(i===0?TOP_LABEL:'');
        var card=document.createElement('div'); card.className='sb-card';
        var iw=document.createElement('div'); iw.className='sb-card-img';
        if(p.img){ iw.style.backgroundImage="url('"+p.img+"')"; } else { var ph=document.createElement('span'); ph.textContent='PRODUKTBILD'; iw.appendChild(ph); }
        if(badge){ var b=document.createElement('span'); b.className='sb-badge'; b.textContent=badge; iw.appendChild(b); }
        card.appendChild(iw);
        var body=document.createElement('div'); body.className='sb-card-body';
        var h3=document.createElement('h3'); h3.textContent=p.title; body.appendChild(h3);
        var price=document.createElement('div'); price.className='sb-price'; price.textContent=p.price;
        var add=document.createElement('button'); add.type='button'; add.className='sb-add';
        if(state.added[p.variantId]){ add.classList.add('is-added'); add.textContent='✓ Hinzugefügt'; }
        else { add.textContent=p.available?'In den Warenkorb':'Nicht verfügbar'; if(!p.available){ add.disabled=true; add.classList.add('is-added'); } }
        add.addEventListener('click',function(){ if(p.available&&!state.added[p.variantId]) addToCart(p,add); });
        var det=document.createElement('a'); det.className='sb-details'; det.href=p.url; det.textContent='Details';
        body.appendChild(price); body.appendChild(add); body.appendChild(det);
        card.appendChild(body); elProducts.appendChild(card);
      });
      /* TEST */ renderDebug();
    }
    function start(){ state.screen='question'; state.step=0; state.answers=[]; state.added={}; renderScreen(); }
    function restart(){ state.screen='intro'; state.step=0; state.answers=[]; state.recommended=[]; state.added={}; renderScreen(); }
    function back(){ if(state.step===0){ state.screen='intro'; } else { state.step--; } renderScreen(); }
    function choose(opt){
      state.answers[state.step]=opt;
      var fb=state.answers.some(function(a){ return a&&a.fallback; });
      if(state.step>=questions.length-1){
        if(fb){ state.screen='fallback'; }
        else { state.recommended=recommend(); state.screen=state.recommended.length?'result':'fallback'; }
        renderScreen();
      } else { state.step++; renderScreen(); }
    }
    function addToCart(p,btn){
      fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:p.variantId,quantity:1}]}) })
        .then(function(r){return r.json();}).then(function(){
          state.added[p.variantId]=true; if(btn){ btn.classList.add('is-added'); btn.textContent='✓ Hinzugefügt'; } afterCart();
        }).catch(function(){ if(btn){ btn.textContent='Erneut versuchen'; } });
    }
    function addAll(){
      var items=state.recommended.filter(function(p){ return p.available&&!state.added[p.variantId]; }).map(function(p){ return {id:p.variantId,quantity:1}; });
      if(!items.length){ afterCart(); return; }
      fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:items}) })
        .then(function(r){return r.json();}).then(function(){
          state.recommended.forEach(function(p){ if(p.available) state.added[p.variantId]=true; }); renderResult(); afterCart();
        }).catch(function(){});
    }
    function afterCart(){
      fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:not([class])').forEach(function(el){ el.textContent=cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        if(CART_MODE==='redirect'){ window.location.href='/cart'; return; }
        if(CART_MODE==='stay'){ return; }
        var drawer=document.querySelector('cart-drawer');
        if(drawer){ document.dispatchEvent(new CustomEvent('cart-drawer:open')); if(typeof drawer.open==='function'){ drawer.open(); } }
      }).catch(function(){});
    }
    root.addEventListener('click',function(e){
      var t=e.target.closest('[data-action]'); if(!t) return;
      var a=t.getAttribute('data-action');
      if(a==='start') start(); else if(a==='restart') restart(); else if(a==='back') back(); else if(a==='addall') addAll();
    });
    renderScreen();
  }
  function boot(){ document.querySelectorAll('.solar-berater').forEach(initOne); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
